import axios from "axios";
import { getHost } from "../helpers/Common";
import { LoginModel } from "../models/LoginModel";
import { EmailPasswordModel } from "../models/EmailPasswordModel";
import { VacancySearchCriteria } from "../models/VacancySearchCriteria";
import saveAs from "file-saver";
import { RecruiterProfileModel, RecruiterPasswordModel } from "../models/RecruiterAccountModel";
import { Organization } from "../models/Organization";
import { BlueLotusPartner } from "../models/BlueLotusPartner";
import { WhitelistedDomain } from "../models/WhitelistedDomain";
import { CandidatesSearchCriteria } from "../models/CandidatesSearchCriteria";
import { ApplicantsSearchCriteria } from "../models/ApplicantsSearchCriteria";
import { StatSearchCriteria } from "../models/StatSearchCriteria";
import { RecruiterInvitation } from "../models/RecruiterInvitation";

const apiBaseUrl = getHost() + "api/";

export async function getPackageDetails(organizationId?: number) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/packages", 
        {            
            params: {
                organizationId: organizationId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getTestimonials(recordsCount: number) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/testimonials", {            
            params: {   
                recordsCount: recordsCount
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getRecruiterQuotaDetails(recruiterId: number, organizationId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/quotaDetails", 
        {            
            params: {   
                recruiterId: recruiterId,
                organizationId: organizationId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function postRecruiterLogin(loginModel: LoginModel){
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "recruiter/login", loginModel)
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postRecruiterProfile(recruiterProfile: RecruiterProfileModel, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "recruiter/profile", recruiterProfile,
        {
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postRecruiterLogout(recruiterId: number, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "recruiter/logout", "recruiterId=" + recruiterId, {
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postRecruiterRegister(formData: FormData) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "recruiter/register", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}
            
export async function getRecruitrProfile(recruiterId: number, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/profile", {            
            params: {         
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function updateRecruiterPassword(passwordModel: RecruiterPasswordModel, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "recruiter/password", passwordModel,
        {
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postLostPasswordRequest(email: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .post(apiBaseUrl + "recruiter/lostPassword", "email=" + email )
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
} 
    
export async function addProfilePicture(formData: FormData, token: string){
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "recruiter/addProfilePicture", formData, {
            headers: {
                "Content-Type" : "multipart/form-data",
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch(error => {
            reject(error);
        })
    })
}

export async function getResetPasswordValidity(id: string, token: string) {  
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "recruiter/resetPasswordValidity", {            
            params: {      
                id: id,
                token: token
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })        
    });
}
    
export async function getOrganizationDetails(recruiterId: number, organizationId: number, isOrganizationAdmin: boolean, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "vacancy/organizationDetails", {
            params: {
                recruiterId: recruiterId,                
                organizationId: organizationId,
                isOrganizationAdmin: isOrganizationAdmin
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postResetPassword(passwordModel: EmailPasswordModel) {    
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "recruiter/resetPassword", passwordModel)
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getJobVacancies(searchCriteria: VacancySearchCriteria, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "vacancy/vacancyList", {
            params: searchCriteria,
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getJobVacancyCounts(searchCriteria: VacancySearchCriteria, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "vacancy/vacancyCounts", {
            params: searchCriteria,
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function duplicateJobVacancies(jobIds: string, recruiterId: number, isSystemAdmin: boolean, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + 'vacancy/duplicate', {}, {            
            params: {
                jobIds: jobIds,
                recruiterId: recruiterId,
                isSystemAdmin: isSystemAdmin
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then(response => {
            resolve(response.data);
        })
        .catch(error => {
            reject(error)
        })
    })
}

export async function archiveJobVacancies(jobIds: string, recruiterId: number, isSystemAdmin: boolean, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + 'vacancy/archive', {}, {   
            params: {
                jobIds: jobIds,
                recruiterId: recruiterId,
                isSystemAdmin: isSystemAdmin
            },         
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then(response => {
            resolve(response.data);
        })
        .catch(error => {
            reject(error)
        })
    })
}

export async function downloadCVLessExcel(recruiterId: number, organizationId: number, startDate: string, endDate: string, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/cvLessExcel", {            
            headers: {
                'Authorization' : `Bearer ${token}`
            },            
            params: {      
                recruiterId: recruiterId,
                organizationId: organizationId,
                startDateStr: startDate,
                endDateStr: endDate
            },
            responseType: 'blob'
        })
        .then((response) => {            
            if(response.status === 200) {
                var blob = new Blob([response.data], {
                    type: response.headers['content-type']
                });  
                let fileName = `CV_less_applications_from_${startDate}_to_${endDate}.xlsx`;                     
                saveAs(blob, fileName);  
            }          
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getOrganization(organizationId: number, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "organization/profile", {            
            params: {        
                organizationId: organizationId,
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function addToExcelCvLessVacancy(jobId: number, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/addToExcelCvLess", {            
            headers: {
                'Authorization' : `Bearer ${token}`
            },            
            params: {
                jobId: jobId,      
                recruiterId: recruiterId
            },
            responseType: 'blob'
        })
        .then((response) => {          
            if(response.status === 200) {
                let filename = 'download.xlsx';
                const contentDisposition = response.headers['content-disposition'];
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1].replace(/['"]/g, '');
                    }
                }
                var blob = new Blob([response.data], {
                    type: response.headers['content-type']
                });
                saveAs(blob, filename);
                resolve(response);
            }          
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getAllUsersList(organizationId: number, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/usersList", {            
            headers: {
                'Authorization' : `Bearer ${token}`
            },            
            params: {
                organizationId: organizationId,      
                recruiterId: recruiterId
            }
        })
        .then(response => {
            resolve(response.data);
        })
        .catch(error => {
            reject(error)
        })
    });
}

export async function updateOrganization(recruiterId: number, organization: Organization, token: string) {   
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "organization/profile", organization,
        {
            params: {        
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStatByJob(model: StatSearchCriteria, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "recruiter/getStatByJob", {
            params: model,
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function sendRequestToRecruiter(email: string, recruiterId : number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + `recruiter/addUser`, {}, {
            params: { email, recruiterId },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function uploadOrganizationLogo(formData: FormData, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "organization/updateLogo", formData, {
            headers: {
                "Content-Type" : "multipart/form-data",
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data)
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function addOrganizationDomain(domain: WhitelistedDomain, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "organization/addDomain", domain,{
            headers: {
                'Authorization' : `Bearer ${token}`,
                 "Content-Type": "application/json"
            }
        })
        .then((response) => {
            resolve(response.data)
        })
        .catch(error => {
            reject(error)
        })
    })
}

export async function getOrganizationDomains(recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "organization/getDomains", {            
            params: {        
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}                              

export async function getStatByDate(model: StatSearchCriteria, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "recruiter/getStatByDate", {
            params: model,
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function removeOrganizationDomain(domain: WhitelistedDomain, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "organization/removeDomain", domain,{
            headers: {
                'Authorization' : `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            resolve(response.data)
        })
        .catch(error => {
            reject(error)
        })
    })
}

export async function addBlueLotusPartner(partner: BlueLotusPartner, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "organization/addPartner", partner,
        {
            params: {
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            resolve(response.data)
        })
        .catch(error => {
            reject(error)
        })
    })
}

export async function getBlueLotusPartners(recruiterId: number, organizationId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "organization/getPartners", {            
            params: {        
                organizationId: organizationId,
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStatByStatus(model: StatSearchCriteria, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "recruiter/getStatByStatus", {
            params: model,
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function removeBlueLotusPartner(partnerId: string, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "organization/removePartner", null,
        {
            params: {
                recruiterId: recruiterId,
                partnerId: partnerId
            },
            headers: {
                'Authorization' : `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            resolve(response.data)
        })
        .catch(error => {
            reject(error)
        })
    });
}

export async function postRecruiterEmailConfirmation(id: number) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .post(apiBaseUrl + `recruiter/emailConfirmation/${id}` )
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getCandidatesByOrg(searchCriteria: CandidatesSearchCriteria, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "recruiter/candidatesByOrg", {
            params: searchCriteria,
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function addCandidate(formData: FormData, recruiterId : number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + `recruiter/addCandidate?recruiterId=${recruiterId}`, formData, {
            headers: {
                'Authorization' : `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getCandidateProfileDetails(candidateId: number, recruiterId: number, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "recruiter/candidateProfile", {
            params: {      
                candidateId: candidateId,
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function sendEmailToCandidates(formData: FormData, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + `recruiter/sendEmail?recruiterId=${recruiterId}`, formData, {
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getPromoCodeValidation(recruiterId: number, promoCode: string, paymentTypeId: number, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios 
        .get(apiBaseUrl + "checkout/recruiterPromoCodeValidation", {
            params: {      
                recruiterId: recruiterId, 
                promoCode: promoCode, 
                paymentTypeId: paymentTypeId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getApplicationStatuses(jobId: number, recruiterId: number, isOrganizationAdmin: boolean, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/applicationStatusList", {   
            params: {      
                jobId: jobId,
                recruiterId: recruiterId,
                isOrganizationAdmin: isOrganizationAdmin
            }, 
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {                
            resolve(response.data);     
        })
        .catch((error) => {
            reject(error);
         })
    });
}

export async function getPromoteAdDetails(jobId: string, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/promoteAd", {            
            headers: {
                'Authorization' : `Bearer ${token}`
            },            
            params: {
                jobId: jobId,      
                recruiterId: recruiterId
            }
        })
        .then(response => {
            resolve(response.data);
        })
        .catch(error => {
            reject(error)
        })
    });
}

export async function getApplicants(searchCriteria: ApplicantsSearchCriteria, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/applicantsList", {   
            params: searchCriteria,  
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {            
            resolve(response.data);         
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function updateApplicationStatuses(jobId: number, applicationStatusId: number, selectedApplicantIds: string, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .put(apiBaseUrl + `vacancy/updateApplicationStatus?jobId=${jobId}&statusId=${applicationStatusId}&applicationIds=${selectedApplicantIds}&recruiterId=${recruiterId}`, {}, {  
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function validateInvitationToken(key: string) {
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "recruiter/accept", {
            params: {      
                id: key
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function downloadApplicantResumes(selectedApplicantIds: string, jobTitle: string, jobId: number, recruiterId: number, downloadAll: boolean, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/applicantResumes", {            
            headers: {                
                'Content-Type': 'application/json',
                'Authorization' : `Bearer ${token}`                
            },             
            params: {      
                applicationIds: selectedApplicantIds,
                jobTitle: jobTitle,
                jobId: jobId,
                recruiterId: recruiterId,
                downloadAll: downloadAll
            },
            responseType: 'blob'
        })
        .then((response) => {
            var blob = new Blob([response.data], {
                type: response.headers['content-type']
            });
            var fileName = "Applicants.zip";
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/i);
                if (utf8Match && utf8Match[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        fileName = filenameMatch[1].replace(/['"]/g, '');
                    }
                }
            }
            saveAs(blob, fileName);              
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function downloadStatToExcel(model: StatSearchCriteria, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/statToExcel", {            
            params: model,
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            responseType: 'blob'
        })
        .then((response) => {            
            if(response.status === 200) {
                let fileName;
                const disposition = response.headers['content-disposition'];
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (match != null && match[1]) {
                        fileName = match[1].replace(/['"]/g, '');
                    }
                }  
                var blob = new Blob([response.data], {
                    type: response.headers['content-type']
                });               
                saveAs(blob, fileName);  
            }
        })
        .catch((error) => {
            reject(error);
        })
    });
}
          
export async function fetchApplicantDetails(candidateId: number, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/applicantDetails", {            
            params: {        
                candidateId: candidateId,
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {   
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getApplicationHistory(applicationId: number, isCvLess: boolean, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/applicationHistory", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {        
                applicationId: applicationId,
                isCVLess: isCvLess,
                recruiterId: recruiterId
            }
        })
        .then((response) => {            
            resolve(response.data);         
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getCVLessAnswers(preApplicationId: number, jobId: number, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/cvLessAnswers", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {        
                preApplicationId: preApplicationId,
                jobId: jobId,
                recruiterId: recruiterId
            }
        })
        .then((response) => {            
            resolve(response.data);         
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getCVBasedAnswers(jobApplicationId: number, recruiterId: number, candidateId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/cvBasedAnswers", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {        
                jobApplicationId: jobApplicationId,
                candidateId: candidateId,
                recruiterId: recruiterId
            }
        })
        .then((response) => {            
            resolve(response.data);         
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getApplicationNote(applicationId: number, isCvLess: boolean, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/applicationNote", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: {        
                applicationId: applicationId,
                isCVLess: isCvLess,
                recruiterId: recruiterId
            }
        })
        .then((response) => {            
            resolve(response.data);         
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function saveApplicationNote(applicationId: number, notes: string, isCvLess: boolean, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + `vacancy/applicationNote`, {}, {  
            params: {      
                applicationId: applicationId,
                notes: notes,
                isCVLess: isCvLess,
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getQuizResults(jobApplicationId: number, recruiterId: number, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios        
        .get(apiBaseUrl + "vacancy/quizResults", {
            params: {      
                jobApplicationId: jobApplicationId,
                recruiterId: recruiterId
            }, 
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function acceptInvitation(recruiterFormData: RecruiterInvitation) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "recruiter/accept", recruiterFormData)
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function updateApplicationReadStatus(recruiterId: number, token: string, preApplicationId?: number, jobApplicationId?: number) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .put(apiBaseUrl + "vacancy/applicationReadStatus", {}, {  
            params: {      
                preApplicationId: preApplicationId,
                jobApplicationId: jobApplicationId,
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getCandidateEmailByRecruiter(emailId: number, recruiterId: number, token: string) { 
    return new Promise<any>((resolve, reject) => {
        axios 
        .get(apiBaseUrl + "vacancy/candidateEmail", {            
            params: {      
                emailId: emailId, 
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getCoverLetter(jobApplicationId: number, recruiterId: number, token: string) { 
    return new Promise<any>((resolve, reject) => {
        axios 
        .get(apiBaseUrl + "vacancy/candidateCoverLetter", {            
            params: {      
                jobApplicationId: jobApplicationId, 
                recruiterId: recruiterId
            },
            headers: {
                'Authorization' : `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function viewCandidateApplicationByEmail(id: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "vacancy/viewApplicationByEmail", {
            params: {
                id: id
            }
        })
        .then((response) => {
            resolve(response.data)
        })
        .catch(error => {
            reject(error)
        })
    })
}

export async function updateApplicationStatusByEmail(jobId: number, applicationStatusId: number, jobApplicationId: number, preApplicationId: number, accessKey: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .put(apiBaseUrl + "vacancy/updateApplicationStatusByEmail", {}, {
            params: {
                jobId: jobId,
                statusId: applicationStatusId,
                jobApplicationId: jobApplicationId,
                preApplicationId: preApplicationId,
                accessKey: accessKey
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function saveApplicationNoteByEmail(jobApplicationId: number, preApplicationId: number, notes: string, isCVLess: boolean, accessKey: string) {
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(apiBaseUrl + "vacancy/applicationNoteByEmail", {}, {  
            params: {      
                jobApplicationId: jobApplicationId,
                preApplicationId: preApplicationId,
                notes: notes,
                isCVLess: isCVLess,
                accessKey: accessKey
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getInvoiceDetails(refId: string, recruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/invoiceDetails", {            
            headers: {
                'Authorization' : `Bearer ${token}`
            },            
            params: {
                refId: refId,      
                recruiterId: recruiterId
            }
        })
        .then(response => {
            resolve(response.data);
        })
        .catch(error => {
            reject(error)
        })
    })
}

export async function getInvoice(invoiceId: number, recruiterId: number, token: string, download: boolean) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/invoice", {            
            params: {
                invoiceId: invoiceId,      
                recruiterId: recruiterId,
                token: token,
                download: download
            },
            responseType: 'blob'
        })
        .then((response) => {            
            const blob = new Blob([response.data], { 
                type: response.headers['content-type']
            });
            const url = URL.createObjectURL(blob);
            resolve({
                url: url,
                blob: blob,
                filename: `INV-${invoiceId}.pdf`
            }); 
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function removeRecruiter(recruiterId: number, loggedRecruiterId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .delete(apiBaseUrl + "recruiter/removeUser", {
            headers: {
                'Authorization' : `Bearer ${token}`
            },            
            params: {
                recruiterId: recruiterId,      
                loggedRecruiterId: loggedRecruiterId
            }
        })
        .then(response => {
            resolve(response.data);
        })
        .catch(error => {
            reject(error)
        })
    })
}

export async function unsubscribeEmail(referenceId: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(apiBaseUrl + "recruiter/emailUnsubscribe", {}, {
            params: {
                referenceId: referenceId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getCandidateCvDetails(recruiterId: number, candidateId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/candidateCvDetails", {
            params: {                
                candidateId: candidateId,
                recruiterId: recruiterId
            },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getCandidateProfileImageUrl(candidateId: number, recruiterId: number, token: string) {
    return new Promise<string>((resolve, reject) => {
        axios
        .get(apiBaseUrl + "recruiter/candidateProfileImageUrl", {
            params: {
                candidateId: candidateId,
                recruiterId: recruiterId
            },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}